import { Link } from 'react-router-dom';
import React from 'react';

function BlackArrowBtn({ to, text }) {
  return (
    <Link
      to={to}
      className="headerContactUsBtn px-24 flex-row gap-8 align-center justify-center"
    >
      <div to={'/contact'} className="textWrap flex-row gap-8 align-center">
        <span>{text}</span>
      </div>
      <div className="iconWrap ">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M6.32324 12H17.6263"
            stroke="white"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M11.9746 6.34863L17.7356 12.0002L11.9746 17.6517"
            stroke="white"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    </Link>
  );
}
export default BlackArrowBtn;
